import { Dispatch, Middleware } from 'redux'
import { message as antdMessage, notification } from 'antd'
import i18next from 'i18next'
import { NotificationAction } from './types'

const notificationMiddleware: Middleware = () => (next: Dispatch) => (action: NotificationAction) => {
  if (action.type !== 'NOTIFICATION') {
    return next(action)
  }
  const { type, message, description, duration } = action.payload
  const title = `${i18next.t(`message:${message}`, message)}!`
  const descriptionText = description && i18next.t(`description:${description}`, description)

  if (type === 'success') {
    // Successes are short confirmations, so they show as a message; errors and info keep the notification,
    // which leaves time to read a longer explanation
    antdMessage.success({ content: descriptionText ? `${title} ${descriptionText}` : title, duration })
  } else {
    notification[type]({ message: title, description: descriptionText, duration })
  }
  return next(action)
}

export default notificationMiddleware
